// extracted by mini-css-extract-plugin
module.exports = {"content":"StudentConduct_content__2JmTC","text":"StudentConduct_text__18BEd"};